/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'add': {
    width: 19,
    height: 18,
    viewBox: '0 0 19 18',
    data: '<path pid="0" d="M18.174 10.25h-7.438v7.5h-2.48v-7.5H.818v-2.5h7.438V.25h2.48v7.5h7.438v2.5z" _fill="#0F0C3D"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/add.js